(function () {
  if (window.inkyboxCardPreviewLoaded) return;
  window.inkyboxCardPreviewLoaded = true;

  const SWIPE_THRESHOLD = 28;
  const DIRECTION_LOCK_THRESHOLD = 6;

  function initInkyboxCardPreview(scope) {
    const previews = scope.querySelectorAll('[data-inkybox-card-preview], [data-product-card-preview]');
    if (!previews.length) return;

    previews.forEach((preview) => {
      if (preview.dataset.previewInit === 'true') return;
      preview.dataset.previewInit = 'true';

      const card = preview.closest('.card-wrapper') || preview.closest('.card') || preview;
      const images = Array.from(preview.querySelectorAll('.product-card-preview__image'));
      const dots = Array.from(card.querySelectorAll('[data-preview-dot]'));
      const prevBtn = preview.querySelector('[data-preview-prev]');
      const nextBtn = preview.querySelector('[data-preview-next]');
      const hoverEnabled = preview.dataset.enableHover !== 'false';
      const mobileSwipeEnabled = preview.dataset.enableMobileSwipe !== 'false';
      const swipeHandoffEnabled = Boolean(preview.closest('[data-inkybox-collection-showcase]'));

      if (!images.length) return;
      images.forEach((img) => {
        img.setAttribute('draggable', 'false');
        img.addEventListener('dragstart', (e) => e.preventDefault());
      });

      let index = 0;
      let hoverIndex = 1;
      let startX = 0, startY = 0, lastX = 0, lastY = 0;
      let direction = null;
      let dragging = false;
      let didSwipe = false;

      function setActive(nextIndex) {
        index = ((nextIndex % images.length) + images.length) % images.length;
        images.forEach((img, i) => img.classList.toggle('is-active', i === index));
        dots.forEach((dot, i) => {
          dot.classList.toggle('is-active', i === index);
          dot.setAttribute('aria-current', i === index ? 'true' : 'false');
        });
        preview.dataset.activeIndex = String(index);
      }
      function next() { if (images.length > 1) setActive(index + 1); }
      function prev() { if (images.length > 1) setActive(index - 1); }
      function stopControlEvent(event) {
        event.preventDefault(); event.stopPropagation();
        if (event.stopImmediatePropagation) event.stopImmediatePropagation();
      }
      function onHoverIn() {
        if (!hoverEnabled || window.matchMedia('(max-width: 749px)').matches || images.length <= 1 || dragging) return;
        preview.classList.add('is-hovering');
        if (images.length === 2) setActive(1);
        else { setActive(hoverIndex); hoverIndex = hoverIndex === 1 ? 2 : 1; }
      }
      function onHoverOut() {
        if (!window.matchMedia('(max-width: 749px)').matches && !dragging) {
          preview.classList.remove('is-hovering'); setActive(0);
        }
      }
      function begin(x, y) {
        if (images.length <= 1) return;
        dragging = true; direction = null; didSwipe = false;
        startX = lastX = x; startY = lastY = y;
        preview.classList.add('is-swiping');
      }
      function move(x, y, event) {
        if (!dragging) return;
        lastX = x; lastY = y;
        const dx = lastX - startX, dy = lastY - startY;
        if (!direction && (Math.abs(dx) > DIRECTION_LOCK_THRESHOLD || Math.abs(dy) > DIRECTION_LOCK_THRESHOLD)) {
          direction = Math.abs(dx) > Math.abs(dy) * 1.15 ? 'horizontal' : 'vertical';
          if (
            direction === 'horizontal' &&
            swipeHandoffEnabled &&
            ((dx < 0 && index === images.length - 1) || (dx > 0 && index === 0))
          ) {
            direction = 'handoff';
          }
        }
        if (direction === 'handoff') {
          didSwipe = true;
          preview.classList.remove('is-horizontal-swipe');
          return;
        }
        if (direction === 'horizontal') {
          didSwipe = true; preview.classList.add('is-horizontal-swipe');
          if (event && event.cancelable) event.preventDefault();
          if (event) event.stopPropagation();
        }
      }
      function end(event) {
        if (!dragging) return;
        const dx = lastX - startX, dy = lastY - startY;
        const handedOff = direction === 'handoff';
        const horizontal = direction === 'horizontal' && Math.abs(dx) > SWIPE_THRESHOLD && Math.abs(dx) > Math.abs(dy) * 1.15;
        dragging = false; direction = null;
        preview.classList.remove('is-swiping', 'is-horizontal-swipe');
        if (handedOff) {
          window.setTimeout(() => { didSwipe = false; }, 180);
        } else if (horizontal) {
          if (event) stopControlEvent(event);
          dx < 0 ? next() : prev();
          window.setTimeout(() => { didSwipe = false; }, 180);
        } else didSwipe = false;
      }

      setActive(0);
      card.addEventListener('mouseenter', onHoverIn);
      card.addEventListener('mouseleave', onHoverOut);

      if (prevBtn) ['pointerdown','touchstart','mousedown','click'].forEach(type => {
        prevBtn.addEventListener(type, (e) => { stopControlEvent(e); if (type === 'click') prev(); }, { passive: false });
      });
      if (nextBtn) ['pointerdown','touchstart','mousedown','click'].forEach(type => {
        nextBtn.addEventListener(type, (e) => { stopControlEvent(e); if (type === 'click') next(); }, { passive: false });
      });
      dots.forEach((dot) => ['pointerdown','touchstart','mousedown','click'].forEach(type => {
        dot.addEventListener(type, (e) => { stopControlEvent(e); if (type === 'click') setActive(Number(dot.dataset.index || 0)); }, { passive: false });
      }));

      preview.addEventListener('touchstart', (e) => { if (mobileSwipeEnabled && e.touches && e.touches.length === 1) begin(e.touches[0].clientX, e.touches[0].clientY); }, { passive: true });
      preview.addEventListener('touchmove', (e) => { if (e.touches && e.touches.length === 1) move(e.touches[0].clientX, e.touches[0].clientY, e); }, { passive: false });
      preview.addEventListener('touchend', end, { passive: false });
      preview.addEventListener('touchcancel', end, { passive: true });
      preview.addEventListener('pointerdown', (e) => {
        if (e.target.closest('[data-preview-prev], [data-preview-next], [data-preview-dot]')) return;
        if (!mobileSwipeEnabled && e.pointerType !== 'mouse') return;
        if (e.pointerType === 'mouse' && e.button !== 0) return;
        begin(e.clientX, e.clientY);
      }, { passive: true });
      preview.addEventListener('pointermove', (e) => move(e.clientX, e.clientY, e), { passive: false });
      preview.addEventListener('pointerup', end, { passive: false });
      preview.addEventListener('pointercancel', end, { passive: true });
      preview.addEventListener('click', (event) => {
        if (event.target.closest('[data-preview-prev], [data-preview-next], [data-preview-dot]')) return;
        if (didSwipe) { stopControlEvent(event); didSwipe = false; return; }
        const url = preview.dataset.productUrl;
        if (url) window.location.href = url;
      });
      preview.addEventListener('keydown', (event) => {
        if (event.key !== 'Enter' && event.key !== ' ') return;
        event.preventDefault();
        const url = preview.dataset.productUrl;
        if (url) window.location.href = url;
      });
    });
  }
  window.initInkyboxCardPreview = initInkyboxCardPreview;
  document.addEventListener('DOMContentLoaded', () => initInkyboxCardPreview(document));
  document.addEventListener('shopify:section:load', (event) => initInkyboxCardPreview(event.target));
})();
